import React from "react";
import { GrayButton } from "../../styles/buttons";
import { HomeGreeting } from "../../styles/texts";
import CasaRuufImage from "./HomeComponents/Images/CasaRuuf.png";
import {
  UserData,
  UserBooking,
  SpecificBooking,
  UserContract,
  PostInstallationDocuments,
  PostInstallationMedia,
} from "../../types/responseTypes";
import ResumeBarPostTermino from "./HomeComponents/Resume/ResumeBarPostTermino";

import getHourlyProductionData from "./getHourlyProductionData";
import { ProductionData } from "../../types/responseTypes";
import { useEffect } from "react";
import getInstallationMedia from "../Installation/getInstallationMedia";

interface HomePostTerminoProps {
  userData: UserData;
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
  userContract?: UserContract | null;
  bookingIndex: number;
  hourlyProductionData: ProductionData[] | null;
  dailyProductionData: ProductionData[] | null;
  installationDocuments: PostInstallationDocuments | null;
  installationMedia: PostInstallationMedia | null;
}
// bookingStep == 5
const HomePostTermino: React.FC<HomePostTerminoProps> = ({
  userData,
  userBooking,
  specificBooking,
  userContract,
  bookingIndex,
  hourlyProductionData,
  dailyProductionData,
  installationDocuments,
  installationMedia,
  }) => {
  console.log("HomePostTermino - CONTRACTS", userContract);

  const findDocumentUrlByName = (name: string) => {
    // si name no es encontrado, retorna undefined y el boton deja de ser clickeable    
    return userContract?.documents.find(doc => doc.name === name)?.url;
  };
  const linkToCredit = findDocumentUrlByName("contrato_creditu");
  //const linkToPrenda = findDocumentUrlByName("prenda");
  //const linkToPagare = findDocumentUrlByName("pagare");
  //const linkToMandato = findDocumentUrlByName("mandato");
  const linkToCompraVenta = findDocumentUrlByName("compraventa");
  
  //const linkToInverter = findDocumentUrlByName(""); //"Ver documento Inversor"
  //const linkToPaneles = findDocumentUrlByName(""); //"Ver documento Paneles"
  //const linkToConnectionWithEnel = findDocumentUrlByName(""); //"Ver documento Conexión con Enel"
  //const linkToCertificate = findDocumentUrlByName(""); //"Ver documento Aprobación SEC"

  const openLink = (link: string | undefined) => {
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  };

  return (
    <div className="mb-10">
      <div className="flex flex-col items-center justify-center mb-10">
        <HomeGreeting userData={userData} userBooking={userBooking} />

        <img
          src={CasaRuufImage}
          alt="Casa Ruuf"
          className="w-1/8 md:w-1/8 mb-4"
        />
        
        {/* Para desarrollo local es util esto hee hee
        <div className="text-3xl font-bold text-gray-800 mb-4">
          Home Post Termino
        </div>
        */}

        <div className="w-full max-w-xl md:max-w-2xl p-4 rounded-lg bg-white shadow-lg">
          <ResumeBarPostTermino 
            userData={userData} 
            userBooking={userBooking} 
            specificBooking={specificBooking} 
            userContract={userContract}
            bookingIndex={bookingIndex}
            hourlyProductionData={hourlyProductionData}
            dailyProductionData={dailyProductionData}
            installationDocuments={installationDocuments}
            installationMedia={installationMedia}
          />
        </div>
        

        {userContract && (
          <div>
            <GrayButton
              label="Crédito Consumo"
              onClick={() => openLink(linkToCredit)}
            />
            <GrayButton
              label="Compra Venta"
              onClick={() => openLink(linkToCompraVenta)}
            />
          </div>
          )
        }
        {!userContract && (
            <div>
              <p>No se encontraron contratos para tu usuario</p>
            </div>
          )
        }

      </div>
  
    </div>
  );
};

export default HomePostTermino;
